import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock,
    BlockType,
    SettingType,
    ValidationMessage,
    ValidationMessageType,
    SettingState,
    TibboDataType,
    FlowEdge,
    IOLinesMode,
    IOMode,
    Setting,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import * as tios from '@appblocks/codegeneration/Tibbits/_IOTibbit/tios';
import * as simulator from '@appblocks/codegeneration/Tibbits/_IOTibbit/simulator';

export default class IOTibbit extends BaseTibbit {
    lines: number;

    mode: IOMode;

    initLines() {
        let settings: Setting[] = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                default: '',
                required: true,
            },
        ];

        for (let i = 1; i <= this.lines; i++) {
            settings = settings.concat({
                id: `L${i}NAME`,
                name: `Line ${i} Name`,
                settingType: SettingType.NAME,
                dataType: TibboDataType.BOOLEAN,
                default: '',
                required: true,
            });

            if (this.mode !== IOMode.OUTPUT) {
                const options = [
                    {
                        name: 'Standard Input',
                        value: IOLinesMode.Standard,
                    },
                    {
                        name: 'Button Input',
                        value: IOLinesMode.Button,
                    },
                ];
                if (this.mode === IOMode.IO) {
                    options.push({
                        name: 'Output',
                        value: IOLinesMode.Output,
                    });
                }
                if (i === 4) {
                    // line 4 for interrupt
                    options.push({
                        name: 'Interrupt',
                        value: IOLinesMode.Interrupt,
                    });
                }
                settings = settings.concat({
                    id: `L${i}MODE`,
                    name: `Line ${i} Mode`,
                    settingType: SettingType.OPTION,
                    default: IOLinesMode.Standard,
                    required: true,
                    options,
                });
                if (i === 4) {
                    settings = settings.concat({
                        id: 'INTEDGE',
                        name: 'Interrupt Edge',
                        settingType: SettingType.OPTION,
                        default: 'INT_EDGE_LOW',
                        required: true,
                        options: [
                            {
                                value: 'INT_EDGE_BOTH',
                                name: 'Both',
                            },
                            {
                                value: 'INT_EDGE_LOW',
                                name: 'Low',
                            },
                            {
                                value: 'INT_EDGE_HIGH',
                                name: 'High',
                            },
                        ],
                    });
                }
            }
        }

        this.settings = this.settings.concat(settings);
    }

    getState(settingId: string): SettingState {
        const currentSocket = Number(this.getSettingValue('SOCKET'));
        const nextSocket = (currentSocket + 1).toString();
        const { project } = this;
        let connector = '';
        let connectorTibbit;

        if (settingId === 'INTEDGE') {
            const line4Mode = this.getSettingValue('L4MODE');
            if (line4Mode !== IOLinesMode.Interrupt) {
                return SettingState.HIDDEN;
            }
        }

        for (let i = 1; i <= this.lines; i += 1) {
            if (settingId === `L${i}STATE`) {
                if ((this.getSettingValue(`L${i}MODE`) !== IOLinesMode.Output)) {
                    return SettingState.DISABLED;
                }
            }
        }
        for (let i = 0; i < project.features.length; i += 1) {
            if (project.features[i].getSettingValue('SOCKET') === nextSocket) {
                connector = project.features[i].getSettingValue('TIBBIT');
                connectorTibbit = project.features[i];
            }
        }

        switch (connector) {
            case '28':
            case '29':
            case '30':
            case '35':
            case '36':
            case '38':
            case '39_1':
            case '39_2':
            case '39_3':
            case '39_4':
            case '41':
                switch (settingId) {
                    case 'L1NAME':
                    case 'L1MODE':
                    case 'L2NAME':
                    case 'L2MODE':
                        return SettingState.DISABLED;
                    default:
                        break;
                }

                break;
            default:

                break;
        }
        return SettingState.ENABLED;
    }

    getCodeBlocks(): CodeBlock[] {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
